import { Box } from "@mui/material";
import { Link } from "@tanstack/react-router";
import { ArrowRight2 } from "iconsax-react";
import { useTranslation } from "react-i18next";

import * as styles from "./CreateShopHeader.styles";

export function CreateShopHeader() {
  const { t } = useTranslation("shops");

  return (
    <Box component="header" sx={styles.root}>
      <Box component="img" src="/images/nav_logo.png" alt="Safano" sx={styles.logo} />
      <Link to="/" style={{ textDecoration: "none" }}>
        <Box component="span" sx={styles.link}>
          <ArrowRight2 size={16} variant="Linear" />
          {t("backToDashboard")}
        </Box>
      </Link>
    </Box>
  );
}
